import { RouteRecordRaw } from 'vue-router';

import { useWalletServiceAutocompleteStore } from '@/store';

// Bank Pay取引履歴関連
export const bankPayTransactionRoutes: Array<RouteRecordRaw> = [
  {
    name: 'BankPayTransaction',
    component: () => import('@/components/pages/bankpay/index.vue'),
    path: '/bankpay-transaction',
    meta: {
      title: 'Bank Pay取引履歴',
      requiredAuthority: ['BANKPAY_TRANSACTIONS'],
    },
    beforeEnter: async (_, __, next) => {
      // TODO: 非同期コンポーネントに寄せることで、ここでの処理は不要になる
      // https://ja.vuejs.org/guide/components/async.html#async-components
      const walletServiceStore = useWalletServiceAutocompleteStore();
      await walletServiceStore.getWalletServices(true);
      next();
    },
  },
  {
    name: 'BankPayTransactionDetail',
    component: () => import('@/components/pages/bankpay/detail/index.vue'),
    path: '/bankpay-transaction/:walletServiceId/:merchantId/:merchantTransactionId',
    meta: {
      title: 'Bank Pay取引履歴詳細',
      requiredAuthority: ['BANKPAY_TRANSACTIONS'],
    },
  },
];
